import React from "react";
import AsyncAutoCompleteContained from "../../AsyncAutoCompleteContained";
import { AutoCompleteProps } from "../../../Types/AutoComplete/AutoCompleteProps"
import { useTranslation } from "react-i18next";

const CompanyAutoComplete: React.FC<AutoCompleteProps> = ({ onChange, valueId, label, load = true, disabled = false, infoText, error, helperText,sx}) => {
    const { t } = useTranslation();
    return (
        <AsyncAutoCompleteContained
            label={label ?? t("common.company")}
            url="/autocompleteApi/Companies"
            valueId={valueId}
            load={load}
            onChange={onChange}
            disabled={disabled}
            infoText={infoText}
            error={error}
            helperText={helperText}
            sx={ sx}
        />
    );
};

export default CompanyAutoComplete;
